import { render, staticRenderFns } from "./UserMapLinking.vue?vue&type=template&id=994eb686&"
import script from "./UserMapLinking.vue?vue&type=script&lang=js&"
export * from "./UserMapLinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports